/* Product photos come from Shopify admin.
   For each site product, find its Shopify product through the variant IDs in shopify.js and use that product's images,
   so photos added or changed in Shopify show on the site. theme.liquid outputs window.KPS_SHOPIFY_IMAGES.
   Products that aren't published on the storefront (drafts, enquiry-only) use the fallbacks below.
   If Shopify has no images for a product, the images set in data.js stay. */
(function () {
  var K = window.KPS;
  if (!K || !K.PRODUCTS || !K.shopify) return;
  var list = window.KPS_SHOPIFY_IMAGES || [], byVar = {};
  list.forEach(function (p) { (p.v || []).forEach(function (id) { byVar[String(id)] = p; }); });
  var CDN = "https://cdn.shopify.com/s/files/1/1031/6319/9669/files/";
  var FALLBACK = {
    tubigrip: [{ src: CDN + "compression-tubi-grip.jpg", alt: "Compression Tubi Grip roll" }],
    secondskin: [{ src: CDN + "hydrogel-blister-protection.jpg", alt: "Hydrogel blister protection patch" }],
    icebath: [{ src: CDN + "kps-ice-bath.jpg", alt: "KPS ice bath with chiller unit" }]
  };
  K.PRODUCTS.forEach(function (p) {
    var hit = null;
    ["unit", "box"].some(function (u) {
      var g = K.shopify.variantFor(p.id + "|" + u);
      hit = g ? byVar[g.split("/").pop()] : null;
      return !!hit;
    });
    var imgs = hit && hit.img && hit.img.length ? hit.img : FALLBACK[p.id];
    if (imgs && imgs.length) p.images = imgs.map(function (i) { return { src: i.src, alt: i.alt || p.name, kind: "Product photo" }; });
  });
})();